import { z } from 'zod'

import { zDiscountApplied } from '@/schemas/discountAppliedSchema'
import { zDiscountRowTypeEnum } from '@/schemas/discountRowTypeEnumSchema'
import { zPriceTypeEnum2 } from '@/schemas/priceTypeEnum2Schema'
import { zSmallestUnitPrice } from '@/schemas/smallestUnitPriceSchema'

export const zPriceValue = z.object({
  // additionalProperties: z.optional(z.record(z.string(), z.record(z.string(), z.unknown()))),
  value: z.number(),
  valueWithVat: z.number(),
  totalValue: z.number(),
  totalValueWithVat: z.number(),
  fullValue: z.number(),
  fullValueWithVat: z.number(),
  fullTotalValue: z.number(),
  fullTotalValueWithVat: z.number(),
  discountAppliedId: z.nullable(z.string()).default(null),
  // netto: z.nullable(z.boolean()).default(false),
  priorityPrice: z.optional(z.boolean()),
  priceType: zPriceTypeEnum2,
  discountRowType: zDiscountRowTypeEnum,
  smallestUnitPrice: z.nullable(zSmallestUnitPrice),
  // productId: z.optional(
  //   z
  //     .string()
  //     .min(1)
  //     .max(255)
  //     .regex(/^[0-9a-zA-Z_-]{1,255}$/)
  // ),
  quantity: z.int(),
  discountApplied: z.nullable(z.array(zDiscountApplied)),
})

export type PriceValueSchema = z.infer<typeof zPriceValue>
